export const ListQueryKey = 'activityZkConfigs';
export const DetailQueryKey = 'activityZkConfig';
export const Urls = {
  selectUrl: '/zkConfig/list',
  updateUrl: '/zkConfig/update',
  deleteUrl: '/zkConfig/delete',
  createUrl: '/zkConfig/create',
  detailUrl: '/zkConfig/detail'
};